import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const getBannerData = (setFormData) => {
  axiosInstance
    .get("/admin/home/get-banners", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Banners retrieved successfully") {
        const data = res.data.data;
        setFormData({
          id: data.id,
          bannerOne: data.bannerOne,
          linkOne: data.linkOne,
          bannerTwo: data.bannerTwo,
          linkTwo: data.linkTwo,
          bannerThree: data.bannerThree,
          linkThree: data.linkThree,
        });
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const addBanner = (FormData, setFormData) => {
  axiosInstance
    .post("/admin/home/add-banners", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Banners added successfully") {
        toast.success("Banners added");
        getBannerData(setFormData);
      } else {
        toast.error("Something went wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const updateBanner = (FormData, setFormData) => {
  axiosInstance
    .post("/admin/home/update-banners", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Banners updated successfully") {
        toast.success("Banners updated");
        getBannerData(setFormData);
      } else {
        toast.error("Something went wrong");
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const getFeaturedHotels = (setFormData) => {
  axiosInstance
    .get("/admin/home/get-featured-hotels", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.data && res.data.data.length > 0) {
        const data = res.data.data;
        setFormData(data);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const addFeaturedHotels = (FormData, setFormData) => {
  axiosInstance
    .post(
      "/admin/home/add-featured-hotels",
      { FormData: FormData },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Featured hotels added successfully") {
        toast.success("Featured hotels added");
        getFeaturedHotels(setFormData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};
export const updatedFeaturedHotels = (FormData, setFormData) => {
  axiosInstance
    .put(
      "/admin/home/update-featured-hotels",
      { FormData: FormData },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Featured hotels updated successfully") {
        toast.success("Featured hotels updated");
        getFeaturedHotels(setFormData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};

export const getFeaturedTours = (setFormData) => {
  axiosInstance
    .get("/admin/home/get-featured-tours", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.data && res.data.data.length > 0) {
        const data = res.data.data;
        setFormData(data);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};

export const addFeaturedTours = (FormData, setFormData) => {
  axiosInstance
    .post(
      "/admin/home/add-featured-tours",
      { FormData: FormData },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Featured tours added successfully") {
        toast.success("Featured tours added");
        getFeaturedTours(setFormData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};
export const updateFeaturedTours = (FormData, setFormData) => {
  axiosInstance
    .put(
      "/admin/home/update-featured-tours",
      { FormData: FormData },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.message === "Featured tours updated successfully") {
        toast.success("Featured tours updated");
        getFeaturedTours(setFormData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};
